import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'

export const useSpacesByPartnerQuery = (partnerId, options = {}) => {
  return useQuery({
    queryKey: QUERY_KEYS.spacesByPartner(partnerId),
    queryFn: () =>
      query({
        query: 'spacesByPartnerIdByUpdatedAt',
        variables: { partner_id: partnerId }
      }),
    ...options
  })
}
